import AboutFundSection from '#app/components/fondo-de-agua/about-fund-section'
import ActionsSection from '#app/components/fondo-de-agua/actions-section'
import IntegralProtectionSection from '#app/components/fondo-de-agua/integral-protection-section'
import { Footer } from '#app/components/footer'
import { HeroCarousel } from '#app/components/hero-carousel'
import OtherProjectsSection from '#app/components/programa-madre/other-projects-section'
import { JoinEffortsSection } from '#app/components/proposito/join-efforts-section'
import { type Route } from './+types/fondo-de-agua'
import { slidesFondoDeAgua } from './config'

export function meta({}: Route.MetaArgs) {
	return [
		{ title: 'Fondo de Agua del Río Mendoza | 100prevalor' },
		{
			name: 'description',
			content:
				'El Fondo de Agua del Río Mendoza es el primer fondo de agua de Argentina, una alianza pionera que garantiza la seguridad hídrica de la cuenca del río Mendoza.',
		},
	]
}

export default function FondoDeAgua() {
	return (
		<>
			{/* Hero Carousel */}
			<HeroCarousel slides={slidesFondoDeAgua} />

			{/* About Fund Section */}
			<AboutFundSection />

			{/* Integral Protection Section */}
			<IntegralProtectionSection />

			{/* Actions Section - ¿Cómo aportamos? */}
			<ActionsSection />

			{/* Other Projects Section */}
			<OtherProjectsSection
				className="bg-gradient-to-r from-blue-500 to-green-500"
				title="Otros proyectos en los que participamos"
				projectImage="/img/programa-madre-card.avif"
				projectTitle="Educa ConCiencia"
				projectLink="/programa-madre"
			/>

			{/* Join Efforts Section - Reused from proposito */}
			<JoinEffortsSection
				title="Vos también podés ser parte del proyecto"
				subtitle="Sumate a nuestra red de personas y organizaciones comprometidas con la seguridad hídrica"
				tagText="Participá"
			/>

			<Footer />
		</>
	)
}
